import { ThemeType } from '../types.js';
const name = 'good-life-plus';
const displayName = 'Good Life Plus';
const type = ThemeType.Default;
const socials = {
    facebookUrl: 'https://www.facebook.com/GoodLifePlusUK',
    instagramUrl: 'https://www.instagram.com/joingoodlifeplus/',
    youtubeUrl: 'https://www.youtube.com/channel/UCR5VzXqBMkIeHsiIAmIT2ig',
    xUrl: 'https://x.com/goodlifeplusuk',
};
// TODO: Move to CMS
const assets = {
    logo: '/assets/images/good-life-plus/logo.svg',
    logoLight: '/assets/images/good-life-plus/logo-light.svg',
    logoMobile: '/assets/images/good-life-plus/logo-sm.svg',
    logoCard: '/assets/images/good-life-plus/logo-card.svg',
    banner: '/assets/images/good-life-plus/banner.jpg',
};
const primitives = {
    theme: {
        extend: {
            colors: {
                white: '#F8FAFC',
                'pure-white': '#FFFFFF',
                primary: '#8C78FF', // purple
                'primary-light': '#CABDFF', // light purple
                'primary-lighter': '#ECE5FD', // lighter purple
                secondary: '#58FE70', // green
                'secondary-dark': '#009215', // dark green
                tertiary: '#FF7300', // orange
                'tertiary-light': '#FF9100', // light orange
                'tertiary-dark': '#FF7300', // orange
                black: '#1E293B',
                'light-black': '#566989',
                teal: '#00ECF0',
                'pastel-blue': '#78A7FF',
            },
        },
    },
};
export default {
    assets,
    displayName,
    name,
    primitives,
    socials,
    type,
};
